module.exports = __webpack_public_path__ + "static/media/marker-on-neutre.e3a833b7.svg";